<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <meta content="" name="description">
  <meta content="" name="keywords">

  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
    rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>

<body>

  <!--Main layout-->
  <main style="margin-top: 40px;">
    <div class="container pt-4"></div>
  </main>
  <!--Main layout-->
  <main id="main">

    <section style="margin-top: 40px;">

      <div class="section-title" data-aos="fade-up">
        <h4 style="text-align: left; margin-left: 140px;"></h4>
      </div>
    </section>


    <section id="blog" class="blog">

      <div class="fondo" data-aos="fade-up">

        <div id="scroll">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Nombre del documento</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr >
                <td>
                  <img src="assets/img/file.png" alt="" height="30" width="30">
                  <a href=" https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR18574G1Montos%20maximos%20y%20minimos%20%20ejercico%20fiscal%202022-2023.pdf?alt=media&token=ce8aea40-9571-4d16-8bed-90385a4801ab"
                   target="_blank" style="text-align: end;">Montos maximos y minimos ejercico fiscal 2022-2023.pdf </a>

                </td>

              </tr>
              <tr >
                <td>
                  <img src="assets/img/file.png" alt="" height="30" width="30">
                  <a href=" https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR18574G1Presupuesto%20de%20egresos%201%20de%20enero%20al%2031%20de%20diciembre%202022.pdf?alt=media&token=2907b61b-a0a4-4fa5-94e4-79239a7191fa"
                   target="_blank" style="text-align: end;">Presupuesto de egresos 1 de enero al 31 de diciembre 2022.pdf </a>

                </td>

              </tr>
              <tr >
                <td>
                  <img src="assets/img/file.png" alt="" height="30" width="30">
                  <a href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR18574G1art.%2015%20montos%20maximos%20y%20minimos..pdf?alt=media&token=8fc4ce51-299f-4ee4-824f-56ec07ff64e2"
                   target="_blank" style="text-align: end;">Art. 15 montos maximos y minimos.pdf </a>

                </td>

              </tr>
              <tr >
                <td>
                  <img src="assets/img/file.png" alt="" height="30" width="30">
                  <a href="https://firebasestorage.googleapis.com/v0/b/autlan-51170.appspot.com/o/Transparencia%2FIPR18574G1Presupuesto%20de%20egresos%201%20de%20enero%20al%2031%20de%20diciembre%202023.pdf?alt=media&token=1bfe605e-cf43-4dcf-8170-ad71bc5adb74"
                   target="_blank" style="text-align: end;">Presupuesto de egresos 1 de enero al 31 de diciembre 2023.pdf </a>

                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>


  </main><!-- End #main -->

  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i
      class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
